import { Repository } from '../../../core/context/repository';
import { type AssetRelation } from './entity';

export class AssetRelations extends Repository<AssetRelation> {}
